// AdminForm.js

import React from 'react';
import { Form, Input, Button } from 'antd';

const AdminForm = () => {
  const [form] = Form.useForm();

  const mainUrl        = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  const insertAdminUrl = `${mainUrl}/insertAdmin`;

  const onFinish = (values) => {
    // Add logic to send the form data to the server or perform other actions
    console.log('Form submitted:', values);
  
    // Make the fetch request here
    fetch(insertAdminUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: values.username,
        password: values.password,
      }),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Response from server:', data);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  
    // Reset the form after submission
    form.resetFields();
  };
  
  const boxHeight = '50px';

  return (
      <Form
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          <Form.Item name="username" 
          rules={[{ required: true, message: 'Please enter the username' }]}
          style={{ fontSize: '16px', flex: '1' }}
          >
            <Input 
            placeholder="Username"
            style={{ height: boxHeight, width: "150%" }}/>
          </Form.Item>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          <Form.Item 
          name="password" 
          rules={[{ required: true, message: 'Please enter the password' }]}
          style={{ fontSize: '16px', flex: '1' }}
          >
            <Input.Password 
            placeholder="Password"
            style={{ height: boxHeight, width: "150%" }}/>
          </Form.Item>
        </div>

        <div style={{ flexWrap: 'wrap', position: 'fixed', right: 30}}>
          <Form.Item>
            <Button 
            type="primary" htmlType="submit" 
            style={{ height: boxHeight, background: "#00308F" }}>
                CREATE ADMIN
            </Button>
          </Form.Item>
        </div>
      </Form>
  );
};

export default AdminForm;
